import { PdContact } from "./pd-contact/PdContact.js";
//#region src/pd-contact/pd-contact.ts
var tag = "pd-contact";
if (!customElements.get(tag)) customElements.define(tag, PdContact);
//#endregion
export { PdContact };
